import { render } from "./expireComponent.vue?vue&type=template&id=7c5bb1ad&scoped=true"
import script from "./expireComponent.vue?vue&type=script&lang=js"
export * from "./expireComponent.vue?vue&type=script&lang=js"

import "./expireComponent.vue?vue&type=style&index=0&id=7c5bb1ad&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5bb1ad"]])

export default __exports__